export default function ($scope, $location, $window, AuthenticationService, FlashService, Restangular) {
    if(GetData().currentUser)
        $location.path('/account');

    $scope.menu = function() {
        $('html').toggleClass("nav-open");
    };

    $scope.recovery = function () {
        $scope.dataLoading = true;

        AuthenticationService.PublicLogin(function(response){
            if(response.status == "200") {
                return Restangular
                    .one('resetpassword', $scope.alias)
                    .get()
                    .then(data => {
                        data = data.data ? data.data : data;

                        $scope.dataLoading = false;

                        FlashService.Success("SEND_EMAIL_REQUEST_SUCCESS");

                        $location.path('/login');

                    }, error => {
                        error = error.data ? error.data : error;

                        FlashService.Error(error.error_description);

                        $scope.dataLoading = false;
                    });
            }else{
                FlashService.Error("INTERNAL_ERROR")

                $scope.dataLoading = false;
            }
        }, true);

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/recovery/controller.js
 **/